/* global $ */

const ExportModal = {
  create(node) {
    this.node = node;

    this.createListeners();
  },

  createListeners() {
    $(this.node).on('change', '[data-toggle-fields]', (e) => {
      const $el = $(e.currentTarget);
      const $target = $(`#${$el.data('toggle-fields')}`);
      const isChecked = $el[0].checked;

      $target.toggle(isChecked);
    });
  },
};

export default ExportModal;
